/** Operations header: ORDERED · UNASSIGNED · READY · DISPATCHED · DELIVERED · TO DELIVER + ONE next action. */
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { BrandPattern } from "@/components/brand/BrandPattern";

const n = (v) => String(Number(v || 0)).replace(/\.0+$/, "");
const TONE = { HIGH: "border-slate-900 bg-slate-900 text-white", MEDIUM: "border-amber-400 bg-amber-50 text-amber-950", LOW: "border-sky-300 bg-sky-50 text-sky-950", DONE: "border-emerald-400 bg-emerald-50 text-emerald-950" };

export function OpsSummary({ s }) {
  const cells = [["ordered", "Ordered"], ["unassigned", "Unassigned"], ["ready", "Ready"], ["dispatched", "Dispatched"], ["delivered", "Delivered"], ["to_deliver", "To deliver"]];
  return (
    <div className="relative grid grid-cols-3 sm:grid-cols-6 overflow-hidden rounded-xl border border-slate-200 bg-white" data-testid="ops-summary">
      <BrandPattern set="dispatch" density="sparse" opacity={0.05} />
      <div aria-hidden="true" className="absolute inset-y-0 left-0 w-1 bg-[color:var(--st-brand)]" />
      {cells.map(([k, l], i) => <div key={k} className={`relative px-3 py-2 ${i % 3 ? "border-l border-slate-100" : ""} ${i >= 3 ? "border-t sm:border-t-0" : ""} ${i === 3 ? "sm:border-l" : ""}`} data-testid={`ops-sum-${k}`}><div className="text-[9px] font-bold uppercase tracking-[0.18em] text-slate-400">{l}</div><div className="font-mono text-xl font-bold text-slate-900">{n(s[k])}</div></div>)}
    </div>
  );
}

export function NextAction({ na, busy, onRun }) {
  const dark = na.tone === "HIGH";
  return (
    <div className={`flex flex-wrap items-center gap-3 rounded-2xl border-2 px-4 py-3 ${TONE[na.tone] || TONE.HIGH}`} data-testid="ops-next-action">
      {na.tone === "DONE" ? <CheckCircle2 className="h-5 w-5 text-emerald-600" /> : <ArrowRight className={`h-5 w-5 ${dark ? "text-sky-300" : ""}`} />}
      <div className="min-w-0 flex-1"><div className={`text-[9px] font-bold uppercase tracking-[0.2em] ${dark ? "text-slate-400" : "opacity-60"}`}>Next action</div><div className="text-[15px] font-semibold leading-snug" data-testid="ops-next-label">{na.label}</div></div>
      {na.cta && <button onClick={onRun} disabled={busy} className={`rounded-full px-5 py-2.5 text-[12px] font-bold tracking-wide transition-transform active:scale-[0.97] disabled:opacity-60 ${dark ? "bg-emerald-500 text-slate-950 hover:bg-emerald-400" : "bg-slate-900 text-white hover:bg-slate-700"}`} data-testid="ops-next-cta">{busy ? "Working…" : na.cta}</button>}
    </div>
  );
}

export function OpsBlock({ id, title, done, children, right }) {
  return (
    <section id={id} className="scroll-mt-24 rounded-xl border border-slate-200 bg-white p-3" data-testid={id}>
      <div className="mb-2 flex flex-wrap items-center gap-2">
        <span className={`grid h-4 w-4 place-items-center rounded-full text-[9px] font-bold ${done ? "bg-emerald-600 text-white" : "bg-slate-200 text-slate-500"}`}>{done ? "✓" : ""}</span>
        <h4 className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-slate-700">{title}</h4>
        <div className="ml-auto flex flex-wrap items-center gap-1.5">{right}</div>
      </div>
      {children}
    </section>
  );
}
